import dictionary from './dictionary'
import miss from './miss'

export default {
  name: 'Dictionary',
  path: 'dictionary',
  meta: {
    label: 'dictionary',
    auth: 'dictionary'
  },
  component: {
    name: 'Dictionary',
    render(c) {
      return c('router-view')
    }
  },
  children: [dictionary, miss]
}
